export default __webpack_public_path__ + "static/media/img_background_slide_five.8c238043.png";